import { Heading, Text } from "@/components/ui/typography";

export function CaseStudyCard({ data }: any) {
  return (
    <div className="flex flex-col gap-2 w-full">
      {/* IMAGE BLOCK */}
      <div
        className="relative h-[370px] rounded-[16px] bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: `url(${data.image})` }}
      >
        {/* overlay content */}
        <div className="absolute bottom-4 left-4 bg-black/70 backdrop-blur-md p-6 rounded-[12px] w-[90%]">
          <Heading as="h4" variant="cardTitleLight">
            {data.title}
          </Heading>
          <Text variant="muted" muted={60} size="sm">{data.type}</Text>
        </div>
      </div>

      {/* STATS */}
      <div className="bg-[#0f1218] rounded-[16px] p-4 flex flex-col min-[450px]:flex-row items-center gap-4">
        {data.stats.map((stat: any, i: number) => (
          <div
            key={i}
            className={`flex flex-col flex-1 text-center md:text-left ${
              i === 1 ? "md:border-x-[2px] md:border-white/10 px-4" : ""
            }`}
          >
            <span className="text-white/60 text-[14px]">{stat.label}</span>
            <span className="text-white font-medium text-[16px]">
              {stat.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
